import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { posponerCita } from "../../CitaPaciente/services/cita.service";

import { successNotification, dangerNotification } from '../../../../redux/slices/ui';

export const useCitaPosponer = (id) => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const posponerCitaMutation = useMutation({
        mutationFn: posponerCita,
        onSuccess: ({ inactivoFlag, horarioFlag, empalmadaFlag, cita }, variables, context) => {
            if(inactivoFlag){
                variables.onInactivo();
            }else if(horarioFlag){
                variables.onHorario();
            }else if(empalmadaFlag){
                variables.onEmpalmada();
            }else{
                queryClient.invalidateQueries({ queryKey: ['citas', id] });
                queryClient.invalidateQueries({ queryKey: ['historialCitas', id] });
                queryClient.invalidateQueries({ queryKey: ['agenda'], exact: false });
                variables.onComplete();
                variables.onSuccess();
                dispatch(successNotification('Cita pospuesta'));
            }

        },
        onError: (error, variables, context) => {
            variables.onComplete();
            dispatch(dangerNotification(error.message));
            // dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        posponerCitaMutation,
    }
}